/**
 * PassiveLivenessTestPage
 * =======================
 * Standalone test page for the passive anti-spoof liveness detection.
 * No backend connection needed — runs entirely in-browser.
 *
 * Access at: /sdk/test-passive-liveness
 */

import React, { useState } from 'react';
import PassiveLivenessStep from './steps/passive-liveness/PassiveLivenessStep';

export default function PassiveLivenessTestPage() {
  const [result, setResult] = useState(null);

  const mockClient = {
    createLivenessSession: async () => ({ session_id: 'test-passive' }),
    completeLiveness: async (sessionId, confidence, data) => {
      console.log('Passive liveness complete:', { sessionId, confidence, data });
    },
  };

  const handleComplete = (data) => {
    setResult(data);
    console.log('Passive liveness result:', data);
  };

  if (result) {
    return (
      <div style={{ maxWidth: '500px', margin: '0 auto', padding: '16px', fontFamily: 'system-ui' }}>
        <h2 style={{ color: result.is_live ? '#10B981' : '#EF4444' }}>
          {result.is_live ? 'PASSED — Real Face Detected' : 'FAILED — Spoof Detected'}
        </h2>
        <div style={{ background: '#F9FAFB', borderRadius: '12px', padding: '16px', marginTop: '16px' }}>
          <p><strong>Confidence:</strong> {result.confidence?.toFixed(1)}%</p>
          <p><strong>Anti-Spoof Score:</strong> {result.anti_spoof_score?.toFixed(4)}</p>
          <p><strong>Frames Analyzed:</strong> {result.frames_analyzed}</p>
          <p><strong>Provider:</strong> {result.provider}</p>
          <p><strong>Selfie Captured:</strong> {result.selfieBlob ? `Yes (${(result.selfieBlob.size / 1024).toFixed(0)}KB)` : 'No'}</p>
        </div>
        <button
          onClick={() => setResult(null)}
          style={{
            marginTop: '16px', padding: '10px 24px', background: '#6366F1',
            color: '#FFF', border: 'none', borderRadius: '8px', cursor: 'pointer',
            fontSize: '14px', fontWeight: '600',
          }}
        >
          Test Again
        </button>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '500px', margin: '0 auto', padding: '8px', fontFamily: 'system-ui' }}>
      <PassiveLivenessStep
        onComplete={handleComplete}
        client={mockClient}
      />
    </div>
  );
}
